var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17.011,
    viewBox: "0 0 17 17.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.74,32.085a.571.571,0,0,0-.543-.043l-4.555,2.025-5.082-2.033a.572.572,0,0,0-.445.009l-4.775,2.122a.571.571,0,0,0-.339.522V47.421a.571.571,0,0,0,.8.522l4.555-2.025,5.082,2.033a.577.577,0,0,0,.445-.009l4.775-2.122A.571.571,0,0,0,48,45.3V32.564A.571.571,0,0,0,47.74,32.085Zm-9.822,1.323,4.163,1.666v11.5l-4.163-1.666Zm-4.775,1.65,3.633-1.614V44.929l-3.633,1.613Zm13.714,9.87-3.633,1.614V35.058l3.633-1.614Z",
    transform: "translate(-31.5 -31.484)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.63d312bc.svg";
export { ForwardRef as ReactComponent };